import { ProductType } from '@schooly/api';
import { newDateTimezoneOffset } from '@schooly/utils/date';
import { isAfter } from 'date-fns';

export const getLatestProductTypes = <T extends Pick<ProductType, 'active_to' | 'created_at'>>(
  types: T[],
  endDate?: string,
) => {
  const date = endDate ? newDateTimezoneOffset(endDate) : new Date();
  const latestTypes = types.filter(({ active_to }) =>
    isAfter(newDateTimezoneOffset(active_to), date),
  );

  if (latestTypes.length) {
    return latestTypes;
  }

  //if no types with future active_to, fallback to latest created types
  //agreed with BE that types of one version will have the same created_at
  const typesByCreatedAt = types.reduce<Record<string, T[]>>((acc, t) => {
    acc[t.created_at] = [...(acc[t.created_at] || []), t];
    return acc;
  }, {});

  const latestCreatedAt = Object.keys(typesByCreatedAt)
    .map(Number)
    .sort((a, b) => b - a)[0];

  if (!latestCreatedAt) {
    return latestTypes;
  }

  return typesByCreatedAt[latestCreatedAt]!;
};
